<template>
    <div>
        <v-container max-width="2500" style="max-width:3000px !important; background: white;">
            <v-card class="mx-auto my-5" max-width="2500">
                <v-system-bar color="#1973a5" dark> Asistencia Pacientes </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5" max-width="2500">
                <v-row>
                    <v-col cols="6" sm="6" md="3" class="mx-3">
                        <v-text-field max-width="200" class="mx-3" v-model="search" label="Clinica"
                            prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="3" class="mx-3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchDNI" label="DNI"
                            prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="3" class="mx-3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchDistrito" label="Distrito"
                            prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="3">
                        <input type="date" v-model="date" id="myDate" class="mx-3" />
                        <v-btn color="#1973a5" dark class="mb-2" @click="filtro">
                            Filtrar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="mx-auto my-5" max-width="2500">
                <!-- <div style="max-height: 70vh;overflow-y: scroll;"> -->
                <v-data-table :headers="headers" :items="filteredData" :item-class="itemClass" :search="search"
                    :sort-by.sync="sortBy">
                </v-data-table>
                <v-row>
                    <v-col>
                        <v-btn color="#1973a5" dark class="mb-2" @click="close" style="margin-left: 1rem;">
                            Cerrar
                        </v-btn>
                    </v-col>
                </v-row>
                <!-- </div> -->
            </v-card>
        </v-container>

        <v-dialog v-model="dialogLoad" hide-overlay persistent width="300" class="fondo-griss">
            <v-card color="primary" dark>
                <v-card-text>
                    Cargando Datos
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--  <v-dialog v-model="dialogDiagrama" v-if="dialogDiagrama" width="1300">
            <Diagrama @closeDiagrama="closeDiagrama"></Diagrama>
        </v-dialog> -->
    </div>
</template>
<style>
.bg-red {
    background: rgb(255 0 0 / 6%);
    color: #df0000 ! important;
    font-weight: 400;
}

.bg-green {
    background: rgb(30 155 16 / 10%);
    color: #129d28 ! important;
    font-weight: 400;
}

.text-start {
    font-size: .8rem !important;
}

.container {
    max-width: 3000px !important;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Gantt from 'frappe-gantt';
/* import Diagrama from "./diagrama.vue"; */
export default {

    data() {
        return {
            searchDNI: null,
            dialogDiagrama: false,
            tasks: [
                { id: 1, name: 'Tarea 1', start: '2024-04-01', end: '2024-04-07' },
                { id: 2, name: 'Tarea 2', start: '2024-04-05', end: '2024-04-10' },
                // Agrega más tareas según sea necesario
            ],
            ganttOptions: {
                header_height: 50,
                column_width: 30,
                step: 24,
                view_modes: ["Quarter Day", "Half Day", "Day", "Week", "Month"],
                bar_height: 20,
                bar_corner_radius: 3,
                arrow_curve: 5,
                padding: 18,
                view_mode: "Day",
                date_format: "YYYY-MM-DD",
                language: "en",
                custom_popup_html: null,
            },
            dialogLoad: false,
            valor1: 15,
            valor2: 10,
            ver: false,
            search: '',
            dataReporte: [],
            dataEnvio: {
                fecha: null
            },
            date: new Date(
                Date.now() - 2592000000 - new Date().getTimezoneOffset() * 60000
            )
                .toISOString()
                .substr(0, 10),
            search: '',
            sortBy: [{ key: 'cupos_disponible', order: 'asc' }],
            headers: [
                { text: "Clinica", align: "start", value: "descripCas" },
                { text: "Distrito", value: "distrito" },
                { text: "Turno", value: "turno" },
                { text: "Frecuencia", value: "frecuencia" },
                { text: "Num. Documento", value: "num_doc" },
                { text: "Serología", value: "tipoPuesto" },
                { text: "Paciente", value: "paciente" },
                { text: "Vig. Seguro", value: "vigSeguro" },
                { text: "Estado", value: "estadoAsistencia" },
                { text: "Fecha ult. diálisis", value: "estadoAsistencia" },
                { text: "Observación", value: "observaFalta" },
            ],
            searchDistrito: null
        };
    },
    methods: {
        close() {
            this.$emit("closeReporte");
        },
        openDiagrama() {
            this.dialogDiagrama = true;
        },
        closeDiagrama() {
            this.dialogDiagrama = false;
        },
        filtro() {
            this.dataEnvio.fecha = this.date
            this.dataEnvio.fecha = this.formatearFecha(this.date)
            console.log(this.formatearFecha(this.date))
            this.dataInit()
        },

        dataInit() {
            this.dialogLoad = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(
                            RUTA_API + "/repAsistenciaPacientes/",
                            this.dataEnvio,
                            {
                                headers: { Authorization: this.auth },
                            }
                        )
                        .then((res) => {

                            console.log("exito", res);
                            this.dataReporte = res.data;
                            this.dialogLoad = false;

                        })
                        .catch((res) => {
                            console.log("Error:", res);
                            this.dialogLoad = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                    this.dialogLoad = false;
                });
        },
        formatearFecha(fecha) {
            // Dividir la fecha en partes: año, mes y día
            const partes = fecha.split('-');
            // Crear una nueva fecha con el formato "mm-dd-yyyy"
            const nuevaFecha = new Date(`${partes[1]}/${partes[2]}/${partes[0]}`);
            // Obtener el mes, día y año de la nueva fecha
            const mes = nuevaFecha.getMonth() + 1;
            const dia = nuevaFecha.getDate();
            const año = nuevaFecha.getFullYear();
            // Formatear la fecha en el formato deseado
            return `${mes.toString().padStart(2, "0")}-${dia.toString().padStart(2, "0")}-${año}`;

        },
        fechaHoy() {
            /* const ahora = new Date();
            // Ajustar la zona horaria a Perú (GMT-5)
            const zonaHorariaPeru = ahora.getTimezoneOffset() + 300; // 5 horas * 60 minutos
            const fechaPeru = new Date(ahora.getTime() + zonaHorariaPeru * 60000); // Convertir minutos a milisegundos
            this.date = fechaPeru.toLocaleDateString('es-PE'); */
            const ahora = new Date();
            const dia = ahora.getDate();
            const mes = ahora.getMonth() + 1;
            const año = ahora.getFullYear();
            // Formatear la fecha en el formato "yyyy-MM-dd"
            this.date = `${año}-${mes < 10 ? '0' + mes : mes}-${dia < 10 ? '0' + dia : dia}`;
        }
    },
    mounted() {
        var tasks = [/* Aquí coloca tus tareas */];

        var gantt = new Gantt("#gantt", tasks, {
            header_height: 50,
            column_width: 30,
            step: 24,
            view_modes: ["Quarter Day", "Half Day", "Day", "Week", "Month"],
            bar_height: 20,
            bar_corner_radius: 3,
            arrow_curve: 5,
            padding: 18,
            view_mode: "Day",
            date_format: "YYYY-MM-DD",
            language: "en", // or 'es', 'it', 'ru', 'ptBr', 'fr', 'tr', 'zh', 'de', 'hu'
            custom_popup_html: null,
        });
        // Access the Gantt instance through the ref
        this.$nextTick(() => {
            /* const gantt = this.$refs.ganttChart.gantt; */
            // You can now access and manipulate the Gantt instance as needed
        });
    },
    computed: {
        itemClass() {
            return (item) => {
                if (item.estadoAsistencia === "ASISTIO") {
                    return "bg-green"; // Aplica la clase "bg-primary" para el color #007bff
                } else {
                    return "bg-red"; // No se aplica ninguna clase
                }
            };
        },
        filteredData() {
            if (!this.search && !this.searchDNI && !this.searchDistrito) {
                return this.dataReporte;
            }
            let filtered = this.dataReporte;
            if (this.search) {
                filtered = filtered.filter((item) =>
                    item.descripCas.toLowerCase().includes(this.search.toLowerCase())
                );
            }
            if (this.searchDNI) {
                filtered = filtered.filter((item) =>
                    item.num_doc.toLowerCase().includes(this.searchDNI.toLowerCase())
                );
            }
            if (this.searchDistrito) {
                filtered = filtered.filter((item) =>
                    item.distrito.toLowerCase().includes(this.searchDistrito.toLowerCase())
                );
            }
            return filtered;
        },
    },
    created() {
        console.log("Hola");
        this.dataInit();
        this.fechaHoy();
    },
    components: {
        /* Diagrama */
    },
};
</script>